import { CORSO_LOGO_URL } from '~/utils/constants';
import { makeLoader } from '~/utils/routing';

export const { loader, useLoaderData } = makeLoader(
  ({ params: { store = '' } }, appStore) => {
    const { order, settings } = appStore.getState();

    return {
      store,
      localizeKey: settings?.localizeKey,
      footerText: settings?.theme.footerText,
      logoUrl: settings?.theme.merchantLogoUrl ?? CORSO_LOGO_URL,
      storeName: settings?.storeName,
      registrationIndex: settings?.registrations.isAutomatedRegistrationEnabled
        ? 'register'
        : 'register/customer-info',
      order,
    };
  },
);

export const shouldRevalidate = () => true;
